import React, { useMemo } from "react";
import { useTrans } from "@/utils/useTrans";
import ExternalLinkIcon from "@/v2-components/core/icon/external-link-icon";
import { cn } from "@/libs/utils";
import { Text } from "@/common/Text";
import { Links } from "@/constants";
import { LinkWrapper } from "@/v2-components/pages/software/components/shared/link-wrapper";
import { Button } from "@/v2-components/ui/button";

export const StudioMainLink = ({ className = "" }: { className?: string }) => {
  const { t } = useTrans(["software"]);
  const components = useMemo(() => getSoftWareLinks(t), [t]);

  if (!components) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex w-full flex-col justify-center gap-x-4 gap-y-4 md:w-fit md:flex-row",
        className,
      )}
    >
      {components.map((component, index) => (
        <div className="flex w-full flex-1 justify-center" key={index}>
          {component}
        </div>
      ))}
    </div>
  );
};

const getSoftWareLinks = (t: (key: string) => string) => {
  const RootClassName =
    "md:w-fit w-full rounded-full bg-black hover:bg-black/70 flex items-center justify-center py-3 px-6 gap-x-[10px]";

  return [
    <LinkWrapper key={1} href={Links.BhapticsStudio} target="_blank">
      <Button
        variant="darkgray-fill"
        shape="pill"
        size="sm"
        className="w-full px-6 md:w-auto"
      >
        <Label text={t("bHaptics Studio")} />
        <ExternalLinkIcon className="max-h-4 max-w-4 text-white" />
      </Button>
    </LinkWrapper>,
  ];
};

const Label = ({ text }: { text: string }) => (
  <Text text={text} className="text-sm font-600 text-white" />
);
